import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from '../../redux/actions';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import _ from 'lodash';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Container,
  Grid,
  Chip,
  Avatar,
} from '@mui/material';
import { ViewTitle } from '../../components/ViewTitle';

export default function ClassroomList({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const me = useSelector((state) => state.me);
  const apply = useSelector((state) => state.apply);

  useEffect(() => {
    dispatch(actions.meGet());
    return () => {};
  }, []);

  useEffect(() => {
    if (me?.userData?._id) {
      dispatch(actions.applyAll({ customer: me?.userData?._id }));
    }
    return () => {};
  }, [me]);

  const renderClassroomList = () => (
    <div>
      {_.map(apply.rows, (item, index) => (
        <Box key={item._id} sx={{ mb: 4 }}>
          {/* หัวข้อคอร์สแบบเรียบง่าย */}
          <Typography
            variant="subtitle1"
            sx={{
              color: '#666',
              fontWeight: 500,
              mb: 2,
              fontSize: '1rem',
            }}
          >
            {item?.name} • {item?.level?.name} • {item?.course?.name}
          </Typography>

          {/* รายการห้องเรียน */}
          <Grid container spacing={2}>
            {_.map(item?.order, (classroom, classIndex) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={classroom._id || classIndex}
              >
                <Card
                  onClick={() => history.push(`/classroom/${classroom._id}`)}
                  sx={{
                    borderRadius: 2,
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    border: '1px solid #e2e8f0',
                    bgcolor: 'white',
                    '&:hover': {
                      borderColor: '#ff9a9e',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    },
                  }}
                >
                  <CardContent sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box
                        sx={{
                          width: 32,
                          height: 32,
                          borderRadius: '50%',
                          bgcolor: '#f7fafc',
                          border: '2px solid #ff9a9e',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mr: 2,
                          fontSize: '0.8rem',
                          fontWeight: 'bold',
                          color: '#ff9a9e',
                        }}
                      >
                        {classIndex + 1}
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            color: '#2d3748',
                            fontWeight: 600,
                            fontSize: '1.1rem',
                            mb: 0.5,
                          }}
                        >
                          {classroom?.name || `ห้องเรียน ${classIndex + 1}`}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: '#718096',
                            fontSize: '0.85rem',
                          }}
                        >
                          แตะเพื่อเข้าสู่ห้องเรียน
                        </Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}

      {/* แสดงเมื่อไม่มีข้อมูล */}
      {(!apply.rows || apply.rows.length === 0) && (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Typography
            variant="h6"
            sx={{
              color: '#a0aec0',
              mb: 1,
              fontSize: '1rem',
            }}
          >
            ยังไม่มีห้องเรียน
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: '#cbd5e0',
              fontSize: '0.85rem',
            }}
          >
            รอการอนุมัติจากอาจารย์
          </Typography>
        </Box>
      )}
    </div>
  );
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  return (
    <div>
      {renderTitle()}
      {renderClassroomList()}
    </div>
  );
}
